import React, { useCallback } from 'react';

import { isMobile, resizeContent } from '../../../../../helpers';
import { JackpotSymbolImages } from '../../../../../constants';
import { JackpotTierName } from '../../../../../enums';
import { JackpotTier } from './jackpot-tier';

interface JackpotTiersProps {
  onTierClick: () => void;
  canvasWidth?: number;
  isWebWithCanvas?: boolean;
}

export const JackpotTiers: React.FC<JackpotTiersProps> = ({
  onTierClick,
  canvasWidth,
  isWebWithCanvas
}) => {

  const jackpotRefCallback = useCallback((element: HTMLDivElement) => {
    if (element && !isMobile() && !canvasWidth) {
      resizeContent({ target: element });
      window.addEventListener('resize', () => resizeContent({ target: element }));
    }
  }, [canvasWidth]);

  return (
    <div
      ref={jackpotRefCallback}
      className="jackpot-main-header"
      style={isWebWithCanvas ? { maxWidth: canvasWidth } : {}}
    >
      <div className="jackpot-main-header-cont club-diamond-cont">
        <JackpotTier
          onClick={onTierClick}
          name={JackpotTierName.Club}
          symbol={JackpotSymbolImages[JackpotTierName.Club]}
        />
        <JackpotTier
          onClick={onTierClick}
          name={JackpotTierName.Diamond}
          symbol={JackpotSymbolImages[JackpotTierName.Diamond]}
        />
      </div>
      <div className="jackpot-main-header-cont">
        <JackpotTier
          onClick={onTierClick}
          name={JackpotTierName.Heart}
          symbol={JackpotSymbolImages[JackpotTierName.Heart]}
        />
        <JackpotTier
          onClick={onTierClick}
          name={JackpotTierName.Spade}
          symbol={JackpotSymbolImages[JackpotTierName.Spade]}
        />
      </div>
    </div>
  );
};
